import { INFO_CONSTANTS } from 'features/Home/constants/infoConstants'
import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

type JointFields = Partial<
  Pick<IPatientSchedule, 'emr_group_id' | 'emr_is_primary' | 'appointment_with'>
>

export type JointProvider = {
  id: number
  name: string
  isPrimary: boolean
}

// The providers of an OpenEMR joint visit, primary first; empty for an ordinary appointment.
export const jointProvidersOf = (appointment: JointFields | undefined): JointProvider[] => {
  if (appointment?.emr_group_id == null) return []
  // The back end lists the primary first; a null flag means the group has no primary.
  const hasPrimary = appointment.emr_is_primary != null

  return (appointment.appointment_with ?? []).map((person, index) => ({
    id: person.consultation_user_id,
    name: person.consultation_user_name || `Provider #${person.consultation_user_id}`,
    isPrimary: hasPrimary && index === 0,
  }))
}

export const joinNames = (names: string[]): string =>
  names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names.at(-1)}` : names[0]

// Names the doctors of a joint visit who are away; the usual warning otherwise.
export const doctorAwayWarning = (names: string[]): string =>
  names.length
    ? `${joinNames(names)} ${
        names.length > 1 ? 'are' : 'is'
      } away or outside available hours during this appointment. Do you still want to continue?`
    : INFO_CONSTANTS.DOCTOR_AWAY_WARNING
